import { getLanguage } from 'tradera-apps/syi/script/app_react/utils/language';

export default state =>
    state
        ? state
        : {
              preferredLanguage: getLanguage()
          };
